import React, { FC } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { FormField } from '../../models/training.models';
import { palette } from '../../theme';

interface NumberFieldComponentProps {
  field: FormField;
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
}

const NumberFieldComponent: FC<NumberFieldComponentProps> = ({ field, value, onChange, disabled = false }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val === '') {
      onChange(null);
    } else {
      const numVal = parseFloat(val);
      if (!isNaN(numVal)) {
        onChange(numVal);
      }
    }
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {field.name}
      </Typography>
      <TextField
        fullWidth
        type="number"
        value={value ?? ''}
        onChange={handleChange}
        disabled={disabled}
        variant="outlined"
        sx={{
          bgcolor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: palette.divider,
            },
          },
        }}
      />
    </Box>
  );
};

export default NumberFieldComponent;
